import { render, staticRenderFns } from "./ExternalApi.vue?vue&type=template&id=c6e07b5e&scoped=true"
import script from "./ExternalApi.vue?vue&type=script&lang=ts"
export * from "./ExternalApi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e07b5e",
  null
  
)

export default component.exports